<template>
  <div class="yhgProductShowList1">
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_wj_addNews')}}</el-button>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight655 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="proprietorNotificationListbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="title" label="名称"></el-table-column>
        <el-table-column prop="type" label="图片">
          <template slot-scope="scope">
            <viewer :images="scope.row.photoUrlsList" class="img-width">
              <img v-for="(src,index) in scope.row.photoUrlsList" v-if="index < 1" :src="src" :key="index" class="img">
            </viewer>
          </template>
        </el-table-column>
        <el-table-column prop="info" label="简介">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light" v-if="scope.row.info&&scope.row.info.length>20"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.info }}
                </span>
              </div>
              <div>
                {{ scope.row.info.substring(0, 20) | valueIsNull }}
                <span v-if="scope.row.info.length>20">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.info | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:yhgProductShowList1
   *@Description:产品展示
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.yhgProductShowList1',
    data() {
      return {
        multipleSelection: [], // 多选框
        type: 1, // 普通产品
        tableData: [], // 产品list
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        proprietorNotificationListbox: require('@/config/enum').proprietorNotificationListbox // 是否隐藏复选框
      }
    },
    created() {
      setTimeout(() => {
        window.localStorage.setItem('yhgProductform1', '')
      }, 200)
      this.getData()
    },
    activated() {
      this.getData()
    },
    methods: {
      // 获取列表数据
      getData() {
        let loading = this.$loading()
        this.$get(`/nProduct?pageNo=${this.pageNo}&pageSize=${this.pageSize}&type=${this.type}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 新增
      add() {
        window.localStorage.setItem('yhgProductform1', '')
        this.$router.push({
          name: 'productShowAdd1',
          query: {
            flag: false
          }
        })
      },
      // 编辑
      edit(rowData) {
        window.localStorage.setItem('yhgProductform1', '')
        this.$router.push({
          name: 'productShowAdd1',
          query: {
            flag: true,
            object: rowData
          }
        })
      },
      // 删除
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/nProduct/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 更新
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    }
  }
</script>

<style lang="scss">
  .yhgProductShowList1 {
    .img-width {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      max-width: 320px;
    }

    .img {
      width: 80px;
      height: 50px;
      border: 1px solid lightgray;
      border-radius: 5px;
      padding: 5px;
    }
  }
</style>